// extracted by mini-css-extract-plugin
export default {"linkContainer":"Dvg0X","link":"QVgT7","icon":"Jtaud"};